import React, { useState } from "react";
import { DotsNine } from "phosphor-react";
import { S3_URL } from "common/constants/apiUrls";

import { getRoutes } from "common/constants/constants";
import { Link, NavLink } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChevronLeft,
  faChevronRight,
  faChevronDown,
  faChevronUp,
} from "@fortawesome/free-solid-svg-icons";
import "./sidePanel.scss";
import { ClickAwayListener } from "@mui/material";
import { useTranslation } from "react-i18next";
const SidePanel = (props) => {
  const { t } = useTranslation();
  const { show, hidePanel } = props;
  return (
    <div className="sidepanel-container">
      <div className={` sidepanel-main ${show ? "showpanel" : "hidepanel"}`}>
        <DotsNine
          onClick={hidePanel}
          weight="bold"
          size={35}
          className="crossbtn"
          cursor="pointer"
          style={{ zIndex: "100000000 !important" }}
        />
        {show && (
          <ClickAwayListener onClickAway={hidePanel}>
            <nav className="linksparent">
              {JSON.parse(localStorage.getItem("products"))?.map((item) => (
                <a
                  className={`menu-linkk ${
                    item?.productKey === "#VdsManagement" && "active"
                  }`}
                  href={item?.redirectUrl}
                  key={item?.productId}
                  target="_blank"
                >
                  <img
                    src={`/assets/icons${item?.imageUrl}`}
                    width={30}
                    height={30}
                  />

                  <span className="heading-smbd"> {t(item?.translatedValue)}</span>
                </a>
              ))}
            </nav>
          </ClickAwayListener>
        )}
      </div>
    </div>
  );
};

export default SidePanel;
